import { gql } from "@apollo/client";
import { TOPIC_ADDITIONAL_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

const CANCEL_CLASS = gql`
  mutation CancelClass($lessonId: ID!) {
    cancelClass(input: { lessonId: $lessonId }) {
      appointment {
        bookedClass {
          id
          date
          time
          startTime
          endHour24hr
          classType
          classSize
          seatsRemaining
          category
          teacher {
            id
            avatar
            givenName
            familyName
          }
          topic {
            ...TopicAdditionalFields
          }
          city {
            id
            name
          }
          level {
            title
          }
          chapter {
            name
          }
          participants {
            id
            name
            avatar
          }
        }
        status
      }
    }
  }
  ${TOPIC_ADDITIONAL_FIELDS_FRAGMENT}
`;

export default CANCEL_CLASS;
